
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-b9e861c6&scoped=true!sass-loader!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./newUser.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./newUser.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-b9e861c6!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./newUser.vue"),
  /* scopeId */
  "data-v-b9e861c6",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/ProductDocument/components/newUser.vue
// module id = 390
// module chunks = 0